import { Action } from "redux";
import { Organization } from "../../../model/Organization";
import { Me } from "../../../model/Me";

export const AUTH_AUTOLOGIN_SUCCESS = "AUTH_AUTOLOGIN_SUCCESS";

export interface AuthAutologinSuccessAction extends Action {
  type: "AUTH_AUTOLOGIN_SUCCESS";
  accessToken: string;
  organizations: Organization[];
  me: Me;
  roles: string[];
}

export const authAutologinSuccessAction = (
  accessToken: string,
  organizations: Organization[],
  me: Me,
  roles: string[]
): AuthAutologinSuccessAction => ({
  type: AUTH_AUTOLOGIN_SUCCESS,
  accessToken,
  organizations,
  me,
  roles,
});
